import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "flex flex-row text-gray-400 items-center" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_4 = {
    key: 1,
    class: "flex flex-row mt-4 text-gray-400"
};
const _hoisted_5 = {
    key: 2,
    class: "flex flex-row mt-4 text-gray-400"
};
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS, ChatType, ChatWidgetSettingsDataOptions, } from '@/helper/const';
import { ensureOption, normalizeOption, removeRandomNumber, updateChatWidgetSetting, } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { InfoCircleIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIFormItem, UIInput, UISelect, UISwitch, UITextXsRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import { isValidUrl } from '@/helper/helper';
import { UIInputGroup, UIInputGroupLabel } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TitleAndIntro',
    setup(__props) {
        const MAX_SELECTION = 5;
        const updateContactFormOptions = (val) => {
            var _a, _b;
            // Remove the 10-digit random number from the start of each value, except for specific values
            val = val.map(option => {
                if (typeof option === 'string') {
                    if (['name', 'phone', 'email', 'message'].includes(option)) {
                        return option;
                    }
                    return removeRandomNumber(option);
                }
                else {
                    if (['name', 'phone', 'email', 'message'].includes(option.value)) {
                        return option;
                    }
                    return Object.assign(Object.assign({}, option), { value: removeRandomNumber(option.value) });
                }
            });
            if (val.length > MAX_SELECTION) {
                val.splice(MAX_SELECTION);
            }
            const normalizedVal = val.map(normalizeOption);
            // Ensure 'name' is the first element
            ensureOption(normalizedVal, '1', 'name', 'Name', 'TEXT', 'contact.name', 'Name');
            const nameIndex = normalizedVal.findIndex(option => option.value === 'name');
            if (nameIndex > 0) {
                const [nameOption] = normalizedVal.splice(nameIndex, 1);
                normalizedVal.unshift(nameOption);
            }
            // Ensure 'phone' or 'email' is the second element
            const phoneIndex = normalizedVal.findIndex(option => option.value === 'phone');
            const emailIndex = normalizedVal.findIndex(option => option.value === 'email');
            if (phoneIndex !== -1) {
                if (phoneIndex > 1) {
                    const [phoneOption] = normalizedVal.splice(phoneIndex, 1);
                    normalizedVal.splice(1, 0, phoneOption);
                }
                if (emailIndex !== -1 && emailIndex > 2) {
                    const [emailOption] = normalizedVal.splice(emailIndex, 1);
                    normalizedVal.splice(2, 0, emailOption);
                }
            }
            else if (emailIndex !== -1) {
                if (emailIndex > 1) {
                    const [emailOption] = normalizedVal.splice(emailIndex, 1);
                    normalizedVal.splice(1, 0, emailOption);
                }
            }
            else {
                ensureOption(normalizedVal, '2', 'phone', 'Phone', 'PHONE', 'contact.phone', 'Phone');
                const newPhoneIndex = normalizedVal.findIndex(option => option.value === 'phone');
                if (newPhoneIndex > 1) {
                    const [phoneOption] = normalizedVal.splice(newPhoneIndex, 1);
                    normalizedVal.splice(1, 0, phoneOption);
                }
            }
            const advanceSettings = (_a = appState.chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings;
            if (advanceSettings) {
                advanceSettings.contactFormOptions = normalizedVal;
            }
            (_b = appState === null || appState === void 0 ? void 0 : appState.chatWidgetSettingsData) === null || _b === void 0 ? true : delete _b.useEmailField;
            appState.unsavedChanges = true;
        };
        const validUrl = ref(false);
        const urlRule = computed(() => ({
            message: 'Please input a valid website',
            trigger: ['input', 'blur', 'change', 'focus'],
            validator: () => {
                const redirectWebsite = appState.chatWidgetSettingsData.advanceSettings.redirect.redirectWebsite;
                return redirectWebsite ? isValidUrl(redirectWebsite) : false;
            },
        }));
        const urlValidator = val => {
            appState.chatWidgetSettingsData.advanceSettings.redirect.redirectWebsite = val;
            validUrl.value = isValidUrl(val);
            if (validUrl.value) {
                updateChatWidgetSetting(ChatWidgetSettingsDataOptions.REDIRECT_WEBSITE, val);
                appState.getCodeButtonDisabled = false;
            }
            else {
                appState.unsavedChanges = false;
                appState.getCodeButtonDisabled = true;
            }
        };
        const handleRedirectAction = val => {
            appState.chatWidgetSettingsData.advanceSettings.redirect.redirectAction = val;
            appState.unsavedChanges = true;
            appState.getCodeButtonDisabled = false;
            if (val) {
                urlValidator(appState.chatWidgetSettingsData.advanceSettings.redirect.redirectWebsite);
            }
            else {
                delete appState.chatWidgetSettingsData.advanceSettings.redirect
                    .redirectWebsite;
            }
        };
        const handleRedirectText = val => {
            appState.chatWidgetSettingsData.advanceSettings.redirect.redirectText = val;
            updateChatWidgetSetting(ChatWidgetSettingsDataOptions.REDIRECT_TEXT, val);
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UIFormItem), {
                    label: _ctx.$t('sidebar.chatWindowTitle'),
                    "show-feedback": false,
                    class: "my-2"
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createVNode(_unref(UIInput), {
                                rows: 4,
                                type: "textarea",
                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.heading,
                                placeholder: _unref(i18n).global.t('placeholder.heading'),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] =
                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).HEADING, val))
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createVNode(_unref(UIFormItem), {
                    label: _ctx.$t('sidebar.introMessage'),
                    "show-feedback": false,
                    class: "my-2"
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createVNode(_unref(UIInput), {
                                rows: 4,
                                type: "textarea",
                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.subHeading,
                                placeholder: _unref(i18n).global.t('placeholder.subHeading'),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).SUB_HEADING, val))
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                (((_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.chatType) !== _unref(ChatType).LIVE_CHAT &&
                    _unref(appState).levelUpCompany)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(UIFormItem), {
                                label: _ctx.$t('sidebar.contactFormOptions'),
                                "show-feedback": false
                            }, null, 8 /* PROPS */, ["label"]),
                            _createVNode(_unref(UITooltip), {
                                trigger: "hover",
                                style: { "width": "300px" },
                                placement: "left"
                            }, {
                                trigger: _withCtx(() => [
                                    _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4 mb-2" })
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.contactFormOptionsHelper2')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createVNode(_unref(UISelect), {
                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_SELECT_BUTTON,
                            value: (_c = (_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.advanceSettings) === null || _c === void 0 ? void 0 : _c.contactFormOptions.map(option => option.value),
                            options: _unref(appState).customFields,
                            clearable: false,
                            multiple: true,
                            type: "default",
                            filterable: true,
                            resetMenuOnOptionsChange: true,
                            placeholder: "Select one",
                            "onUpdate:value": updateContactFormOptions
                        }, null, 8 /* PROPS */, ["id", "value", "options"]),
                        _createVNode(_unref(UITextXsRegular), { class: "mt-1" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sidebar.contactFormOptionsHelper')), 1 /* TEXT */),
                                _hoisted_3,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.contactFormOptionsHelper2')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(UISwitch), {
                            rubberBand: false,
                            value: (_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.useEmailField,
                            "onUpdate:value": _cache[2] || (_cache[2] =
                                val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).USE_EMAIL_FIELD, val))
                        }, null, 8 /* PROPS */, ["value"]),
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.emailField'),
                            "show-feedback": false,
                            class: "ml-2 mt-0.5"
                        }, null, 8 /* PROPS */, ["label"])
                    ])),
                _createVNode(_unref(UIFormItem), {
                    class: "my-2",
                    label: _ctx.$t('sidebar.cta'),
                    "show-feedback": false
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createVNode(_unref(UIInput), {
                                type: "text",
                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.sendActionText,
                                placeholder: _unref(i18n).global.t('placeholder.sendActionText'),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] =
                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).SEND_ACTION_TEXT, val))
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                (((_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.chatType) !== _unref(ChatType).WA_CHAT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_unref(UISwitch), {
                            rubberBand: false,
                            value: (_h = (_g = (_f = _unref(appState).chatWidgetSettingsData) === null || _f === void 0 ? void 0 : _f.advanceSettings) === null || _g === void 0 ? void 0 : _g.redirect) === null || _h === void 0 ? void 0 : _h.redirectAction,
                            "onUpdate:value": handleRedirectAction
                        }, null, 8 /* PROPS */, ["value"]),
                        _createElementVNode("div", null, [
                            _createVNode(_unref(UIFormItem), {
                                label: _ctx.$t('sidebar.redirectAction'),
                                "show-feedback": false,
                                class: "ml-2 mt-0.5"
                            }, null, 8 /* PROPS */, ["label"]),
                            _createVNode(_unref(UITextXsRegular), { class: "ml-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.redirectActionHelper')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                ((_l = (_k = (_j = _unref(appState).chatWidgetSettingsData) === null || _j === void 0 ? void 0 : _j.advanceSettings) === null || _k === void 0 ? void 0 : _k.redirect) === null || _l === void 0 ? void 0 : _l.redirectAction)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 3,
                        class: "my-2",
                        label: _ctx.$t('sidebar.redirectText')
                    }, {
                        default: _withCtx(() => {
                            var _a, _b, _c;
                            return [
                                _createVNode(_unref(UIInput), {
                                    type: "text",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.redirect) === null || _c === void 0 ? void 0 : _c.redirectText,
                                    placeholder: _unref(i18n).global.t('placeholder.redirectText'),
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = val => handleRedirectText(val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                ((_p = (_o = (_m = _unref(appState).chatWidgetSettingsData) === null || _m === void 0 ? void 0 : _m.advanceSettings) === null || _o === void 0 ? void 0 : _o.redirect) === null || _p === void 0 ? void 0 : _p.redirectAction)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 4,
                        class: "my-2",
                        label: _ctx.$t('sidebar.redirectWebsite'),
                        rule: _unref(urlRule),
                        required: true
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIInputGroup), { style: { "max-width": "400px" } }, {
                                default: _withCtx(() => {
                                    var _a, _b, _c;
                                    return [
                                        _createVNode(_unref(UIInputGroupLabel), null, {
                                            default: _withCtx(() => [
                                                _createTextVNode("https://")
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_unref(UIInput), {
                                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                            modelValue: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.redirect) === null || _c === void 0 ? void 0 : _c.redirectWebsite,
                                            placeholder: _unref(i18n).global.t('placeholder.redirectWebsite'),
                                            "onUpdate:modelValue": urlValidator
                                        }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                                    ];
                                }),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "rule"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
